import { CSSObject } from '@emotion/react'
import { fonts, fontSizes } from '@opallabs/pulsar'

const sharedStyles = {
  iconLightGray: '#d8d8d8',
  textShadow: '0 1px 6px rgba(0, 0, 0, 0.3)',
}

const accountImage: CSSObject = {
  boxShadow: sharedStyles.textShadow,
}

const withCollab = 'with-collab'
const withCollabSelector = `.kuiper-${withCollab}`

const accountName: CSSObject = {
  margin: '0 5px 0 8px',
  maxWidth: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

const loaderWrapper: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
  paddingBottom: '12px',
  width: '354px',
}

const getLoaderStyle = (isActive: boolean): CSSObject => ({
  backgroundColor: isActive ? 'white' : 'rgba(255, 255, 255, 0.5)',
  borderRadius: '1px',
  boxShadow: sharedStyles.textShadow,
  height: '2px',
  marginRight: '3px',
  width: '100%',
})

const headerWrapper: CSSObject = {
  color: 'white',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: fonts.sansSerif,
  fontSize: fontSizes.medium,
  margin: '8px 12px 0 12px',
  marginBottom: '-58px',
  position: 'relative',
  textShadow: sharedStyles.textShadow,
  zIndex: 1,
}

const accountHeaderWrapper: CSSObject = {
  display: 'flex',
  flexDirection: 'row',
  height: '36px',
  justifyContent: 'space-between',
  width: '100%',
}

const flexCenterRow: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'row',
  minWidth: 0,
  [`&${withCollabSelector} .kuiper-account-name`]: {
    flex: '0 1 auto',
    maxWidth: 'none',
    minWidth: 0,
  },
}

const headerIcons: CSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  flexShrink: 0,
  listStyle: 'none',
}

const headerIconMore: CSSObject = {
  color: sharedStyles.iconLightGray,
  display: 'flex',
  filter: `drop-shadow(${sharedStyles.textShadow})`,
  flexDirection: 'column',
  marginRight: '24px',
}

const headerIconClose: CSSObject = {
  filter: `drop-shadow(${sharedStyles.textShadow})`,
}

const collabAvatarContainer: CSSObject = {
  height: 36,
  position: 'relative',
  width: 36,
  flexShrink: 0,
  div: { display: 'block' },
  'div:nth-of-type(2)': {
    display: 'block',
    marginLeft: 12,
    marginTop: -16,
    position: 'absolute',
  },
}

const collabAvatarSecondary: CSSObject = {
  ...accountImage,
  backgroundColor: 'rgb(208, 218, 225)',
}

const collabSeparator: CSSObject = {
  color: 'white',
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 'normal',
  whiteSpace: 'pre',
}

const styles = {
  accountHeaderWrapper,
  accountImage,
  accountName,
  collabAvatarContainer,
  collabAvatarSecondary,
  collabSeparator,
  flexCenterRow,
  getLoaderStyle,
  headerIconClose,
  headerIconMore,
  headerIcons,
  headerWrapper,
  loaderWrapper,
  withCollab,
}

export { styles }
